import { Component, ElementRef, OnDestroy, OnInit, HostListener, ViewChild, AfterViewChecked } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Event, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/core/token/token.service';
import { LoginService } from 'src/app/services/login.service';
import { environment } from 'src/environments/environment';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EsqueceuSenhaComponent } from "src/app/components/modais/esqueceu-senha/esqueceu-senha.component";
import { ModalTrialComponent } from "src/app/components/modais/modal-trial/modal-trial.component";
import { ModalAvisoNotificacaoComponent } from "src/app/components/modais/modal-aviso-notificacao/modal-aviso-notificacao.component";
import { Subscription } from 'rxjs';
import { DeviceInfo, DeviceDetectorService } from 'ngx-device-detector';
import { SimpleCrypt } from 'ngx-simple-crypt';
import { LocalstorageService } from 'src/app/core/localstorage/localstorage.service';
import { ModalReenviarCodigoDoisFatoresComponent } from 'src/app/components/modais/modal-reenviar-codigo-dois-fatores/modal-reenviar-codigo-dois-fatores.component';
import { Usuario } from 'src/app/models/usuario.model';
import { ModalResetPasswordComponent } from 'src/app/components/modais/modal-reset-password/modal-reset-password.component';
import { ILoginAutomaticoRequest, iLoginRequest, iUserToEncode, iUsuario } from 'src/app/interfaces/login/login.interface';
import { ThemeService } from "src/app/shared/themes/theme.service";
import { Theme } from 'src/app/shared/themes/theme';
import * as CryptoJS from 'crypto-js';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewChecked {

  @ViewChild('slogan', { static: false }) slogan: ElementRef;
  @ViewChild('sloganFormatado', { static: false }) sloganFormatado: ElementRef;
  errorMessage: string = null;
  loginForm: UntypedFormGroup;
  submitted: boolean = false;
  focus1: any
  focus: any
  selector: string;
  usuario: iUsuario;
  avisos;
  newSubs: Subscription;
  empresa: any;
  deviceInfo: DeviceInfo;
  isValid: boolean = true;
  email_codificado: string = '';
  email: string = '';
  codigoForm: UntypedFormGroup;
  mostraLembrarDispositivo: boolean = true;
  tema: string;
  isMultiSessao: any;

  constructor(
    public translate: TranslateService,
    private loginService: LoginService,
    private tokenService: TokenService,
    private route: Router,
    private _fb: UntypedFormBuilder,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private elemRef: ElementRef,
    private router: ActivatedRoute,
    private storageService: LocalstorageService,
    private deviceDectectorService: DeviceDetectorService,
    private themeService: ThemeService,
  ) {
    this.selector = this.elemRef.nativeElement.tagName.toLowerCase();
    this.translate.addLangs(['pt', 'en', 'es']);
    translate.setDefaultLang('pt');
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/pt|en|es/) ? browserLang : 'pt');
    this.tema = this.themeService.getActiveTheme().name;
  }

  ngOnInit(): void {
    this.buildForm();
    if (this.router.snapshot.params.loginAutomatico && this.router.snapshot.params.loginAutomatico === 'true') {
      this.loginAutomatico();
      return;
    } else if (this.tokenService.hasToken()) {
      this.route.navigate(['/dashboards']);
    }
    this.checkValueLembrarDispositivo();

    this.translate.addLangs(['pt', 'en', 'es']);
    this.translate.setDefaultLang('pt');
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang.match(/pt|en|es/) ? browserLang : 'pt');
    
    if(window.localStorage.getItem('sessao_expirada')) {
      this.toastr.show(window.localStorage.getItem('sessao_expirada'), "", {
        disableTimeOut: true,
        closeButton: false,
        enableHtml: true,
        tapToDismiss: true,
        titleClass: 'alert-title',
        positionClass: 'toast-top-center',
        toastClass: "ngx-toastr alert alert-dismissible alert-danger alert-notify",
      });

      setTimeout(() => {
        window.localStorage.removeItem('sessao_expirada');
      }, 2000);
    }
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  ngAfterViewChecked(): void {
    this.formatarSlogan();
  }

  formatarSlogan() {
    if (this.slogan.nativeElement) {
      const texto = this.translate.instant('SLOGAN_LOGIN');
      const elem = this.slogan.nativeElement as HTMLElement;
      const novoTexto = texto.split(' ')
        .map((palavra: string, index: number) => {
          if (index === 0 || palavra === 'atenda' || palavra === 'atienda' || palavra === 'serve') {
            return `<strong>${palavra}</strong>`;
          }
          return palavra;
        })
        .join(' ');

      elem.innerHTML = novoTexto;
    }
  }

  rememberThisDevice(event) {
    // this.codigoForm.get('lembrar').setValue(event.target.checked)
    if (event.target.checked === true) {
      this.setDadosBrowserLocalStorage(this.getDadosBrowser());
      this.setValueLembrarDispositivoLocalStorage();
    } else {
      this.storageService.removeStoredItem('dados_browser');
      localStorage.removeItem('lembrarDispositivo');
    }
  }

  invalidParams() {
    this.openAutenticacaoDoisFatores();
  }

  checkValueLembrarDispositivo() {
    if (localStorage.getItem('lembrarDispositivo')) {
      this.mostraLembrarDispositivo = false;
    }
  }

  setValueLembrarDispositivoLocalStorage() {
    if (localStorage.getItem('lembrarDispositivo')) {
      localStorage.removeItem('lembrarDispositivo');
    }

    let encodedObjectAsString: string = SimpleCrypt.encodeDefault("szHYxd7tz", this.codigoForm.get('lembrar').value);
    localStorage.setItem('lembrarDispositivo', encodedObjectAsString);
  }

  loginAutomatico(): void {
    setTimeout(() => {
      let usuario: ILoginAutomaticoRequest = {
        "email": this.router.snapshot.params.username,
        "password": this.router.snapshot.params.password,
        "loginAutomatico": true
      };

      this.newSubs = this.loginService.authenticathionLogin(usuario)
        .subscribe(results => {
          if(results) {
            if (this.verifyResetPassword(usuario, results)) return;
            var userToEncode = results.usuario;
            userToEncode['permissoes'] = results.permissoes.permissoes;
            userToEncode['empresa'] = results.empresa;
            userToEncode['possui_widget'] = results.possui_widget;
            userToEncode['ultimo_login'] = new Date();
            userToEncode['dispositivo_id'] = results.dispositivo_id;
            userToEncode['possui_workflows'] = results.possui_workflows;
            userToEncode['tipo_usuario_id'] = results.tipo_usuario ? results.tipo_usuario.id : null;
            userToEncode['forma_cobranca_id'] = results.forma_cobranca ? results.forma_cobranca.id : null;
  
            this.errorMessage = null;
  
            if (results.utiliza_endereco_release === true && results.link_redirecionamento !== '') {
              window.location.href = results.link_redirecionamento;
            } else {
              this.tokenService.setToken(userToEncode); 
              setTimeout(() => {
                this.usuario = results.usuario;
                this.translate.use(this.translate.getLangs()[this.usuario.idioma - 1]);
  
                if (userToEncode['empresa'].is_trial && userToEncode['empresa'].tempo_restante_trial === 0) {
                  this.tokenService.setTrialExpirado();
                  this.route.navigate(['trial/free-trial-ended']);
                } else {
                  this.dispatchEventAfterLoginAutomatic(this.usuario);
                  this.redirect(results.usuario.tela_inicial_id);
                }
  
                if (userToEncode['empresa'].tempo_restante_trial !== 0) {
                  setTimeout(() => {
                    this.abrirModalTrial()
                  }, 2000)
                }
              }, 500);
            }
          }
        }, error => {
          this.errorMessage = error;
          this.submitted = false;
        });
    }, 1000)
  }

  dispatchEventAfterLoginAutomatic(user): void {
    var event = new CustomEvent("login-automatic-success", { "detail": user });
    document.dispatchEvent(event);
    this.getTrialEmpresa(user.AccessToken);
    this.getNotificacao(user.AccessToken);
  }

  buscaDataBloqueio(token) {
    this.newSubs = this.loginService.buscaDataBloqueio(token).subscribe(
      (result) => {
        window.localStorage.setItem("empresa_data_bloqueio", result.data_bloqueio);
      }
    )
  }

  getTrialEmpresa(token): void {
    this.newSubs = this.loginService.getTrialEmpresa(token)
      .subscribe(results => {
        this.empresa = results.empresa;
        if (results.empresa.is_ativa) {
          this.loginService.getSituacaoEmpresa(token)
            .subscribe(resultsEmpresa => {
              window.localStorage.setItem("empresa_situacao_id", resultsEmpresa.empresaSituacao.tipo_situacao_id);
              if (resultsEmpresa.empresaSituacao.tipo_situacao_id === 3 || resultsEmpresa.empresaSituacao.tipo_situacao_id === 2) {
                if (resultsEmpresa.empresaSituacao.data_bloqueio === null) {
                  this.buscaDataBloqueio(token);
                } else {
                  window.localStorage.setItem("empresa_data_bloqueio", resultsEmpresa.empresaSituacao.data_bloqueio);
                }
              }
            })
        }
      })
  }

  openAutenticacaoDoisFatores() {
    this.isValid = false;
    let email = this.email.includes('@') ? this.email : this.loginForm.get('email')!.value;
    this.email_codificado = email ? `${email.substring(0, 2)}*******@${email.split('@')[1]}` : `${this.translate.instant('NAO_POSSUI')}`;
  }

  saveLocalStorageDeviceId(deviceId?) {
    if (deviceId && (this.codigoForm.get('lembrar')!.value === true)) {
      this.storageService.storageItemSimple('deviceId', deviceId)
    }
  }

  checkLocalStorageDeviceId() {
    return !this.storageService.getStoredItemSimple('deviceId')
  }

  getAcessoPortal(results, userToEncode) {
    if(results) {
      if (results.utiliza_endereco_release === true && results.link_redirecionamento !== '') {
        window.location.href = results.link_redirecionamento;
      } else {
        setTimeout(() => {
          this.usuario = results.usuario;
          this.translate.use(this.translate.getLangs()[this.usuario.idioma - 1]);
  
          this.saveLocalStorageDeviceId(userToEncode.dispositivo_id);
          this.tokenService.setToken(userToEncode);
  
          if (userToEncode.empresa.is_trial && userToEncode.empresa.tempo_restante_trial === 0) {
            this.tokenService.setTrialExpirado();
            this.route.navigate(['trial/free-trial-ended']);
          } else if(window.localStorage.getItem('bc_redirect_auth')) {
            this.route.navigate(['outside-auth/confirm-auth']);
          } else {
            this.dispatchEventAfterLoginAutomatic(this.usuario);
            this.redirect(results.usuario.tela_inicial_id);
          }
  
          if (userToEncode.empresa.is_trial === true && userToEncode.empresa.tempo_restante_trial !== 0) {
            setTimeout(() => {
              this.abrirModalTrial();
            }, 2000)
          }
        }, 500);
      }
    }
  }

  setUserToEncode(result) {
    if(result) {
      this.getTrialEmpresa(result.AuthenticationResult.AccessToken);
      this.getNotificacao(result.token || result.AuthenticationResult.AccessToken);
      this.loginForm.patchValue({
        session: result.session
      })
      var userToEncode = result.usuario;
      userToEncode['permissoes'] = result.permissoes.permissoes;
      userToEncode['empresa'] = result.empresa;
      userToEncode['possui_widget'] = result.possui_widget;
      userToEncode['ultimo_login'] = new Date();
      userToEncode['listaIsNew'] = result && result.listaIsNew && result.listaIsNew.lista ? result.listaIsNew.lista : []
      userToEncode['dispositivo_id'] = result.dispositivo_id;
      userToEncode['possui_workflows'] = result.possui_workflows;
      userToEncode['tipo_usuario_id'] = result.tipo_usuario ? result.tipo_usuario.id : null;
      userToEncode['UserSession'] = result.usuario?.UserSession;
      userToEncode['forma_cobranca_id'] = result.forma_cobranca ? result.forma_cobranca.id : null;
      
      this.errorMessage = '';
      this.getAcessoPortal(result, userToEncode);
    }
  }

  getDadosBrowser(): DeviceInfo | {} {
    this.deviceInfo = this.deviceDectectorService.getDeviceInfo();
    return this.deviceInfo || {};
  }

  setDadosBrowserLocalStorage(dados) {
    localStorage.removeItem('dados_browser')
    if (dados) {
      let encodedObjectAsString: string = SimpleCrypt.encodeDefault("szHYxd7tz", dados);
      localStorage.setItem('dados_browser', encodedObjectAsString);
    }
  }

  getDadosBrowserLocalStorage() {
    let decode: any = {};
    if (localStorage.getItem('dados_browser')) {
      decode = SimpleCrypt.decodeDefault('szHYxd7tz', localStorage.getItem('dados_browser')!);
    }
    return decode;
  }

  checkDadosBrowser() {
    var check = false;
    if (localStorage.getItem('dados_browser')) {
      var _dadosBrowser = this.getDadosBrowser();
      var _dadosBrowserLocalStorage = this.getDadosBrowserLocalStorage();
      check = JSON.stringify(_dadosBrowser) === JSON.stringify(_dadosBrowserLocalStorage);
    }

    return check
  }

  withAuthenticathionLogin() {
    let usuario: iLoginRequest = {
      //"username": this.loginForm.get('email').value,
      email: this.loginForm.get('email')!.value,
      password: this.loginForm.get('senha')!.value,
      // lembrar: this.loginForm.get('lembrar').value,
      dados_browser: this.getDadosBrowser()
    };
    this.newSubs = this.loginService.authenticathionLogin(usuario)
      .subscribe(results => {
        if (this.verifyResetPassword(usuario, results)) return;
        if (results.email) {
          this.email = results.email;
        }
        this.errorMessage = '';
        this.checkSessionCognito(results);
      }, error => {
        this.submitted = false;
      });
  }

  withoutAuthenticathionLogin() {
    let dadosBrowser = this.getDadosBrowser()
    let usuario: iLoginRequest = {
      email: this.loginForm.get('email')!.value,
      password: this.loginForm.get('senha')!.value,
      // lembrar: this.loginForm.get('lembrar').value,
      dados_browser: dadosBrowser,
      deviceId: this.storageService.getStoredItemSimple('deviceId')
    };

    this.newSubs = this.loginService.authenticathionLogin(usuario)
      .subscribe(results => {
        if (this.verifyResetPassword(usuario, results)) return;
        this.errorMessage = '';
        this.checkSessionCognito(results);
      }, error => {
        this.submitted = false;
      });
  }

  login(): void {
    if (this.loginForm.invalid) {
      this.toastr.show(this.translate.instant('CAMPOS_VAZIOS_LOGIN_POPUP'), '', environment.toastrConfig("danger"));
      this.errorMessage = this.translate.instant('CAMPOS_VAZIOS_LOGIN');
      return;
    }

    this.submitted = true;

    setTimeout(() => {
      if (!this.checkLocalStorageDeviceId()) {
        this.withoutAuthenticathionLogin();
      } else {
        this.withAuthenticathionLogin();
      }
    }, 1000);
  }

  checkSessionCognito(object: any): void {
    
    if (object.hasOwnProperty('session')) {
      this.errorMessage = '';
      this.loginForm.patchValue({
        session: object.session
      });
      this.invalidParams();
    } else if(object.possui_sessao_ativa) {
      this.isValid = false;
      this.isMultiSessao = object;
      this.usuario = object;
    } else {
      this.setUserToEncode(object)
      document.dispatchEvent(new Event('login'));
    }
  }

  getNotificacao(token) {
    this.newSubs = this.loginService.buscarNotificacoes(token).subscribe(
      (result) => {
        if(result.avisos) {
          this.avisos = result.avisos;
          if (this.avisos.length > 0) {
            this.avisos.forEach(element => {
              setTimeout(() => {
                this.abrirModalAvisoNotificacao(element.descricao)
              }, 2000)
            });
          }
        }
      }, (error) => {
        console.log(error);
      }
    )
  }

  abrirModalAvisoNotificacao(descricao) {
    const modalRef = this.modalService.open(ModalAvisoNotificacaoComponent, {
      backdrop: 'static',
      windowClass: 'modal-custom-milvus',
      keyboard: false,
      scrollable: false,
      size: 'grande'
    })
    modalRef.componentInstance.descricao = descricao;
    modalRef.result.then((result) => {
    });
  }

  buildForm(): void {
    this.loginForm = this._fb.group({
      email: ['', [Validators.required, Validators.email]],
      senha: ['', [Validators.required]],
      code: [null],
      loginAutomatico: [0],
      session: ['']
    })

    this.codigoForm = this._fb.group({
      validacao_primeiro: ["", Validators.required],
      validacao_segundo: ["", Validators.required],
      validacao_terceiro: ["", Validators.required],
      validacao_quarto: ["", Validators.required],
      validacao_quinto: ["", Validators.required],
      validacao_sexto: ["", Validators.required],
      lembrar: [this.checkDadosBrowser()],
    });
  }

  openModal() {
    const modalRef = this.modalService.open(EsqueceuSenhaComponent, {
      backdrop: "static",
      windowClass: 'modal-custom-milvus',
      keyboard: true,
      scrollable: false,
      size: "pequeno",
    });

    modalRef.result.then((result) => {
    });
  }

  abrirModalTrial(): void {
    const modalRef = this.modalService.open(ModalTrialComponent,
      {
        backdrop: 'static',
        windowClass: 'modal-custom-milvus',
        keyboard: false,
        scrollable: false,
        size: 'medio'
      });
  }

  abrirModalTrialBloqueado(): void {
    const modalRef = this.modalService.open(ModalTrialComponent,
      {
        backdrop: 'static',
        windowClass: 'modal-custom-milvus',
        keyboard: false,
        scrollable: false,
        size: 'medio'
      });

    modalRef.result.then((result) => {
      if (this.empresa.tempo_restante_trial < 1) {
        this.route.navigate(['trial/free-trial-ended']);
      } else {
        this.redirect(this.usuario.tela_inicial_id);
      }
    });
  }

  redirect(tela_id): void {
    switch (tela_id) {
      case 1:
        //principal
        this.route.navigate(['/dashboards/main']);
        break;
      case 2:
        //tickets
        this.route.navigate(['/dashboards/ticket']);
        break;
      case 3:
        //sla
        this.route.navigate(['/dashboards/sla']);
        break;
      case 5:
        //chat
        this.route.navigate(['/dashboards/chat']);
        break;
      case 6:
        //tarefas
        this.route.navigate(['/dashboards/tasks']);
        break;
      case 7:
        //monitoramento de link
        this.route.navigate(['/dashboards/link-monitoring']);
        break;
      case 8:
        //vulnerabilidade
        this.route.navigate(['/dashboards/vulnerability']);
        break;
      case 9:
        //inventario
        this.route.navigate(['/dashboards/inventory']);
        break;
      case 10:
        //tecnico
        this.route.navigate(['/dashboards/technician']);
        break;
      case 11:
        //mesas
        this.route.navigate(['/dashboards/tables']);
        break;
      case 12:
        //classificacao interna
        this.route.navigate(['/dashboards/internal-classification']);
        break;
      case 14:
        //dashboards
        this.route.navigate(['/dashboards']);
        break;
      case 15:
        //dashboards users status
        this.route.navigate(['/dashboards/users-status']);
        break;
      default:
        this.route.navigate(['/dashboards']);
        break;
    }
  }

  autoTab(field1, field2, event): void {
    if (field1 && (<HTMLInputElement>document.getElementById(field1)).value.length == 1 && event.event.keyCode !== 8) {
      document.getElementById(field2).focus();
    } else if (event.event.keyCode === 8 && event.field) {
      document.getElementById(event.field).focus();
    }
  }

  @HostListener('paste', ['$event'])
  eventPaste(e): void {
    if(e && e.clipboardData) {
      let event = (e.clipboardData).getData("text");
      this.setValuesAuthCode(event);
    }
  }

  @HostListener('document:keypress', ['$event'])
  eventEnter(event): void {
    if(event && event.key) {
      let x = event.key;
      if (x === 'Enter' && !this.codigoForm.invalid) {
        this.confirmCode();
      }
    }
  }

  setValuesAuthCode(paste): void {
    if (paste) {
      var _arrAux = Array.from(paste);
      _arrAux = _arrAux.slice(0, _arrAux.length > 6 ? 5 : _arrAux.length)
      var cont = 0;
      for (const field in this.codigoForm.controls) {
        if (field && field !== 'lembrar') {
          this.codigoForm.controls[field].setValue(
            this.checkValueArrayPaste(_arrAux[cont])
          );
          cont++;
        }
      }
    }
  }

  checkIsLoginToRemoveKeypress(): boolean {
    return window.location.href.includes('login');
  }

  checkValueArrayPaste(value): any {
    var _aux = '';
    if (value && !isNaN(value)) {
      _aux = value.toString()
    }
    return _aux;
  }

  concatCharCode(): string {
    var _auxString = ''
    for (const field in this.codigoForm.controls) {
      if (field && field !== 'lembrar') {
        _auxString += this.codigoForm.controls[field].value;
      }
    }
    return _auxString;
  }

  confirmCode(): void {
    var payload =
    {
      code: this.concatCharCode(),
      email: this.loginForm.get('email').value,
      password: this.loginForm.get('senha').value,
      lembrar: this.codigoForm.get('lembrar').value,
      session: this.loginForm.get('session').value,
      dados_browser: this.getDadosBrowser()
    }

    this.newSubs = this.loginService.authenticathionLogin(payload).subscribe(
      (result) => {
        if (this.verifyResetPassword(payload, result)) return;
        if(result.possui_sessao_ativa) {
          this.isValid = false;
          this.isMultiSessao = result;
        } else {
          this.setUserToEncode(result);
        }
      }, (error) => {
        console.error(error);
        this.toastr.show(this.translate.instant('AVISO_ERRO_AUTENTICACAO'), "", environment.toastrConfig("danger"));
      }
    )
  }

  resendCode(): void {
    const modalRef = this.modalService.open(ModalReenviarCodigoDoisFatoresComponent, {
      backdrop: "static",
      windowClass: "modal-custom-milvus",
      keyboard: true,
      size: "pequeno",
      scrollable: false,
      centered: true,
    });

    modalRef.componentInstance.email_login = this.email;

    modalRef.result.then((result) => {
      this.withAuthenticathionLogin();
    });
  }

  verifyResetPassword(userInfos, apiResponse): boolean {
    if (apiResponse.precisar_alterar_senha) {
      const modalRef = this.modalService.open(ModalResetPasswordComponent, {
        keyboard: false,
        backdrop: "static",
        scrollable: false,
        size: "medio",
        windowClass: "modal-custom-milvus"
      });

      modalRef.componentInstance.userInfos = userInfos;
      modalRef.result.then(
        (results) => {
          if (results) {
            this.toastr.show(this.translate.instant('CONTINUAR_LOGIN_APOS_RESET_SENHA'), '', environment.toastrConfig('success'));
            this.submitted = false;
          }
        }
      )
      return true;
    } else {
      return false;
    }
  }

  encerraSessoes(object): void {
    this.newSubs = this.loginService.encerraOutrasSessoes(object.AuthenticationResult.AccessToken, this.storageService.getStoredItemsByName('dispositivo_id'))
      .subscribe({
        next: (result) => {
          let userToEncode = object;
          if(object.usuario && result && result.UserSession) {
            object.usuario.UserSession = result.UserSession;
          }
          this.setUserToEncode(userToEncode);
        }
      });
  }
}
